"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = _interopRequireDefault(require("immutable"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Big = _interopRequireDefault(require("UIComponents/elements/Big"));

var _UIBreakString = _interopRequireDefault(require("UIComponents/text/UIBreakString"));

var _UIClickable = _interopRequireDefault(require("UIComponents/button/UIClickable"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIButtonWrapper = _interopRequireDefault(require("UIComponents/layout/UIButtonWrapper"));

var _UILightbox = _interopRequireDefault(require("UIComponents/lightbox/UILightbox"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  white-space: pre-line;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var IMAGE_WIDTH = 280;

var WorkingParagraph = _styledComponents.default.p.withConfig({
  displayName: "Workings__WorkingParagraph",
  componentId: "sc-198vrqp-0"
})(_templateObject());

var Workings = function Workings(_ref) {
  var onTrackInteraction = _ref.onTrackInteraction,
      workings = _ref.workings;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      focusedIndex = _useState2[0],
      setFocusedIndex = _useState2[1];

  var renderedLightbox = (0, _react.useMemo)(function () {
    var working = workings.get(focusedIndex);

    if (!working) {
      return null;
    }

    return _react.default.createElement(_UILightbox.default, {
      imageAlt: working.get('text'),
      imageSrc: working.get('imageUrl'),
      onClose: function onClose() {
        return setFocusedIndex(null);
      }
    }, _react.default.createElement(_UIButtonWrapper.default, null, working.get('text')));
  }, [workings, focusedIndex]);
  return _react.default.createElement(_react.Fragment, null, workings.map(function (working, index) {
    return _react.default.createElement(_UISection.default, {
      key: "working-" + index
    }, _react.default.createElement(_UIGrid.default, null, _react.default.createElement(_UIGridItem.default, {
      size: {
        sm: 12,
        md: 7
      }
    }, _react.default.createElement(_Big.default, {
      weight: "bold"
    }, _react.default.createElement(_UIBreakString.default, null, working.get('headline'))), _react.default.createElement(WorkingParagraph, null, _react.default.createElement(_UIBreakString.default, null, working.get('text')))), _react.default.createElement(_UIGridItem.default, {
      size: {
        sm: 12,
        md: 5
      }
    }, _react.default.createElement(_UIClickable.default, {
      onClick: function onClick() {
        setFocusedIndex(index);
        onTrackInteraction('click working screenshot', 'overview');
      }
    }, _react.default.createElement(_UIImage.default, {
      responsive: true,
      src: working.get('imageUrl'),
      width: IMAGE_WIDTH
    })))));
  }), renderedLightbox);
};

Workings.propTypes = {
  onTrackInteraction: _propTypes.default.func.isRequired,
  workings: _propTypes.default.instanceOf(_immutable.default.List).isRequired
};
var _default = Workings;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/overview/Workings.js
// module id = 818
// module chunks = 209 210 211 212